// Фронт открыт и на lcab.crmcalls.ru, и на lcab.crmcalls.site (переезд 02.11.2026) — API и ссылки берём с того же домена.
export const BASE_DOMAIN =
  typeof window !== 'undefined' && /(^|\.)crmcalls\.site$/.test(window.location.hostname) ? 'crmcalls.site' : 'crmcalls.ru'
